// extracted by mini-css-extract-plugin
export default {"container":"f0-z","list":"g0-z"};